export const GET_COMPANY = Symbol('GET_COMPANY');
export const GET_COMPANY_REQUEST = Symbol('GET_COMPANY_REQUEST');
export const GET_COMPANY_SUCCESS = Symbol('GET_COMPANY_SUCCESS');
export const GET_COMPANY_ERROR = Symbol('GET_COMPANY_ERROR');

